import countries from "i18n-iso-countries";
import pt from "i18n-iso-countries/langs/pt.json";

countries.registerLocale(pt);

/**
 * Nome do país em português (Brasil) pelo código ISO 3166-1 alpha-2.
 */
export function getCountryNamePt(code) {
  if (!code || typeof code !== "string") return "";
  const c = code.trim().toUpperCase();
  if (c.length !== 2) return "";
  return countries.getName(c, "pt") || "";
}

/**
 * @returns {{ code: string, name: string }[]} ordenado por nome em PT
 */
export function getSortedCountryOptions() {
  const codes = Object.keys(countries.getAlpha2Codes());
  return codes
    .map((code) => ({ code, name: countries.getName(code, "pt") || code }))
    .filter((o) => o.name)
    .sort((a, b) => a.name.localeCompare(b.name, "pt"));
}
